<template>
  <div class="_content">
    <div class="main-bg">
      <div class="main-bg-name">
        <p class="main-switch">
          <img
            class="main-logo"
            src="https://res.xiaokunkeji.cn/image/2023/12/07/04638af030304facb5768e9720cf974f.png"
            alt=""
          />
          <span class="main-shop-name">{{ currentShopData.shopName }}</span>
        </p>
        <p class="main-switch-ed" v-if="shopList.length > 1" @click="showAllShop = true">
          切换
        </p>
      </div>
    </div>
    <div class="main-content">
      <!-- <div class="exchange-area">
			<div class="shop-name bottom-line">
				<span>{{currentShopData.shopName}}</span>
				<span v-if="shopList.length > 1" class="switchShop" @click="showAllShop=true">切换</span>
				<img v-if="shopList.length > 1" class="switchShop" @click="showAllShop=true" src="~@/imgs/images/change.png" alt="">
			</div>
			<div class="list">
				<div v-if="allOrder" class="total item" @click="handleClick2(tabList1[0])" >总订单<span> {{currentShopData.orderCount || 0}} 单</span></div>
				<div v-if="todayOrder" class="todayOrder item" @click="handleClick2(tabList2[0])">今日订单<span> {{currentShopData.todayOrderCount}} 单</span></div>
			</div>
		</div> -->

      <div class="entry-order-num">
        <div class="order-content" @click="handleClick2(tabList1[0])">
          <span>{{ currentShopData.orderCount || 0 }} </span>
          <span>总订单</span>
          <!-- <span>不含抖音订单</span> -->
        </div>
        <div class="order-content" @click="handleClick2(tabList2[0])">
          <span>{{ currentShopData.todayOrderCount || 0 }}</span>
          <span>今日订单</span>
          <!-- <span>不含抖音订单</span> -->
        </div>
      </div>
      <!--小鲲车服订单结算流程说明-->
      <slideTip :billFlag="userInfo.billFlag" @showSlide="handleShowSlide"></slideTip>

      <div class="entry-content" v-if="veryCoupon">
        <div class="entry-item" @click="scanQrcode" v-if="shopStatus == 1">
          <img
            class="enter-img"
            src="https://res.xiaokunkeji.cn/image/2023/12/07/a05ff421a59b4acbb37f775abfbf02b2.png"
            alt=""
          />
          <span>扫一扫</span>
        </div>
        <div class="entry-item" v-else @click="handleOpenTips">
          <img
            class="enter-img"
            src="https://res.xiaokunkeji.cn/image/2023/12/07/a05ff421a59b4acbb37f775abfbf02b2.png"
            alt=""
          />
          <span>扫一扫</span>
        </div>
        <div class="entry-item" v-if="shopStatus == 1" @click="handleVerify">
          <img
            class="enter-img"
            src="https://res.xiaokunkeji.cn/image/2023/12/07/e65bc35ae1734dd4a57eeec7ccfd2292.png"
            alt=""
          />
          <span>消费码</span>
        </div>
        <div class="entry-item" v-else @click="handleOpenTips">
          <img
            class="enter-img"
            src="https://res.xiaokunkeji.cn/image/2023/12/07/e65bc35ae1734dd4a57eeec7ccfd2292.png"
            alt=""
          />
          <span>消费码</span>
        </div>
      </div>

      <div class="entry-content" v-if="tpVisible">
        <!-- 暂时用不到 -->
        <!-- <div class="entry-item btn" v-if="CollectionAccount && CollectionAccount.indexOf('SDSYT_XK') != -1
          " @click="handleGoToSD">
          <img class="enter-img" style="width: 4.15rem; height: 2.2rem" src="~@/imgs/images/XD_PAY.png" alt="" />
          <span>杉德收款</span>
        </div>
        <div class="entry-item btn" v-if="CollectionAccount && CollectionAccount.indexOf('RXSYT_XK') != -1
          " @click="handleGoToRX">
          <img class="enter-img" style="width: 4.3rem; height: 1.4rem; margin-top: 2rem" src="~@/imgs/images/RX_PAY.png"
            alt="" />
          <span>瑞祥收款</span>
        </div> -->
        <div class="tp-entry-item">
          <p class="tp-flex">
            <span class="tp-name">太平财险核销</span>
            <img
              class="tp-logo"
              src="https://res.xiaokunkeji.cn/image/2023/12/14/06cf60bc65ab48cd90fc031e49cbbb53.png"
              alt=""
            />
          </p>
          <img
            class="tp-enter-code"
            @click="handleGoToTP"
            src="https://res.xiaokunkeji.cn/image/2023/12/14/b019730365cd4e62b3412570c43c1a61.png"
            alt=""
          />
        </div>
      </div>

      <div class="entry-dy-zone" v-if="currentShopData.tiktokShop">
        <div class="dy-zone-name">
          <p class="name">抖音核销专区</p>
          <p class="text">鲲鲲养车</p>
        </div>
        <div class="dy-zone-record">
          <div class="flex-row" @click="handleDyZone('/pages/dayRecord/index')">
            <span class="num">{{ tiktokOrder.verifyOrderSum || 0 }}</span>
            <p>今日订单</p>
          </div>
          <div class="flex-row" @click="handleDySRcode()">
            <img src="https://res.xiaokunkeji.cn/image/2023/12/07/658afb910bb94d5d852131b52717eda4.png" alt="" />
            <p>扫码核销</p>
          </div>
          <div class="flex-row" @click="handleDyZone('/pages/yearRecord/index')">
            <img src="https://res.xiaokunkeji.cn/image/2023/12/07/149eff069f034ec2b50a3381eabb9392.png" alt="" />
            <p>核销记录</p>
          </div>
          <div class="flex-row" @click="tiktokVisible = true">
            <img src="https://res.xiaokunkeji.cn/image/2023/12/07/7cfaafe997024455b2007f420df8a744.png" alt="" />
            <p>结算说明</p>
          </div>
        </div>
        <!-- </div> -->
      </div>

      <div class="main-entry-ed">
        <p class="main-entry-name">服务功能</p>
        <div class="main-entry">
          <div
            class="entry-item entry-item-ed"
            @click="handleClick(item)"
            v-for="(item, index) in tabList"
            :key="index"
          >
            <div class="item-img">
              <div class="entry-badge" v-show="item.badge">{{ item.badge }}</div>
              <img class="item-img" :src="item.icon" alt="" />
            </div>
            <span v-text="item.name"></span>
          </div>
        </div>
      </div>

      <div
        class="concat"
        v-if="marketManage"
        v-call="{
          tel: currentShopInfo && currentShopInfo.managerPhone ? currentShopInfo.managerPhone : '400-176-8848'
        }"
      >
        <van-icon name="phone" color="#8AB2FB" />
        <span>直接拨打门店专员电话</span>
      </div>
    </div>

    <van-popup v-model="showAllShop" position="bottom" :style="{ height: '30%' }">
      <van-radio-group v-model="radio" class="shoplist-popup">
        <van-cell
          :class="{
            'shop-item': true,
            selected: currentShopData.id === item.id
          }"
          v-for="(item, index) in shopList"
          :key="index"
          @click="handleSelect(item)"
          :clickable="true"
        >
          <!-- <template > -->
          <van-radio :name="index">{{ item.shopName }}</van-radio>
          <!-- </template> -->
        </van-cell>
      </van-radio-group>
    </van-popup>

    <!-- 提示模板 -->
    <van-dialog v-model="tipsVisible" :showConfirmButton="false" class="custormTips">
      <p class="title">小鲲车服结算流程调整通知</p>
      <p class="tips"><img :src="icon1" alt="" />非常重要，请务必仔细阅读！</p>
      <div class="t-content">
        <p class="name">尊敬的小鲲车服合作商户：</p>
        <p class="text">
          &nbsp;&nbsp;&nbsp;&nbsp;您好！感谢一直以来对小鲲车服的支持。为更灵活、更方便的向各位商户结算服务费用，同时避免出现打款错误的情况发生（如：门店收款信息变更），小鲲车服对结算流程进行了优化调整：
          <span>由系统每月自动生成结算单，调整为由您在商户端进入【结算管理】栏目自行申请结算！</span
          >具体流程说明请查看详情。
        </p>
        <p @click="closeTipsVisible" class="t-btn">查看详情</p>

        <p @click="closeTipsVisible2" class="close">我已知晓该通知内容</p>
      </div>
    </van-dialog>

    <!-- 抖音订单结算说明 -->
    <van-dialog v-model="tiktokVisible" :showConfirmButton="false" class="custormTips1">
      <p class="title">抖音订单结算说明</p>
      <p class="tips1"><img :src="icon1" alt="" />非常重要，请务必仔细阅读！</p>
      <div class="t-content">
        <p class="name">尊敬的小鲲车服合作商户：</p>
        <p class="text">
          &nbsp;&nbsp;&nbsp;&nbsp;您好！感谢一直以来对小鲲车服的支持。我司在抖音的业务是以<span>鲲鲲养车</span>品牌进行的推广，您的门店在抖音推广的店名均带有<span>鲲鲲养车</span>字样，凡是用户在<span>鲲鲲养车</span>字样门店购买的服务请务必使用小鲲商户端抖音专区进行扫码核销，核销成功后服务结算款项将由抖音在次日（T+1）打款至您的银行账户，如对结算有疑问，可致电小鲲车服商户专员或客服!
        </p>
        <div
          @click="
            () => {
              tiktokVisible = false
            }
          "
          class="t-btn"
        >
          我知道了
        </div>
      </div>
    </van-dialog>

    <!-- 通用提示 -->
    <van-dialog v-model="visiblePopup" :showConfirmButton="false" class="custormTips3">
      <p class="title">温馨提示</p>
      <div class="t-content">
        <p class="name">尊敬的小鲲合作商户：</p>
        <p v-html="commonText"></p>
        <p class="service-provider">小鲲车服商户管理中心</p>
        <img :src="btn" alt="" class="t-btns" @click="visiblePopup = false" />
      </div>
    </van-dialog>
    <!-- 提示需签订协议 -->
    <van-dialog
      v-model="visibleAssign"
      :showConfirmButton="true"
      :showCancelButton="true"
      confirmButtonText="去签署"
      title="提示"
      @confirm="toAssignMent"
      class="custormTips4"
    >
      <p class="t-content4">您好,合作协议已更新需重新签署</p>
    </van-dialog>
    <div v-for="item in noticeDialogs" :key="item.id" v-show="item.show">
      <!-- id=4 营业确认弹窗（最高优先级，排第一） -->
      <holiday-confirm
        v-if="currentIndex === 0 && item.show"
        :visible="item.show"
        :shopId="currentShopData.shopId"
        @close="handleClose(item.id)"
      ></holiday-confirm>
      <sildePopup
        v-if="currentIndex === 1 && item.show"
        :visible="item.show"
        :slideId="item.containSlideId"
        @close="handleClose(item.id)"
      ></sildePopup>
      <sildePopup2
        v-if="currentIndex === 2 && item.show"
        :visible="item.show"
        :slideId="item.containSlideId"
        @close="handleClose(item.id)"
      ></sildePopup2>
      <sildePopup3
        v-if="currentIndex === 3 && item.show && userInfo.role === '老板'"
        :visible="item.show"
        @close="handleClose(item.id)"
      ></sildePopup3>
    </div>
  </div>
</template>

<script>
import sildePopup from './components/sildePopup.vue'
import sildePopup2 from './components/sildePopup2.vue'
import sildePopup3 from './components/sildePopup3.vue'
import slideTip from './components/slideTip.vue'
import holidayConfirm from './components/holidayConfirm.vue'
import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
// import defaultImg from "@/imgs/image/defaultHead.png";
import homeCar from '@/imgs/image/home_car.png'
// import homeOwner from "@/imgs/image/home_owner.png";
import homeOrder from '@/imgs/image/home_order.png'
// import homeSettlementRecords from "@/imgs/image/home_settlementRecords.png";
// import homeAccounts from "@/imgs/image/home_accounts.png";
// import washcar from "@/imgs/image/washcar.png";
import kefu from '@/components/kefu'
import config from '@/configs/config'
import wx from 'weixin-js-sdk'
// import WxConfig from "../../../lib/commons/wxconfig";
// import compareTime from "@/commons/secret";
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

const enterList = [
  {
    name: '门店信息',
    key: 'shopInfo',
    icon: 'https://res.xiaokunkeji.cn/image/2023/12/07/3ffc29b178ef4e5f9ec8ed04ddda1559.png',
    url: '/pages/shopInfo/index',
    badge: null
  },
  {
    name: '门店服务',
    key: 'shopService',
    icon: 'https://res.xiaokunkeji.cn/image/2023/12/07/ffe206fb74244d10929c842acc0c36cf.png',
    url: '/pages/shopService/index',
    badge: null
  },
  {
    name: '员工管理',
    key: 'userManagement',
    icon: 'https://res.xiaokunkeji.cn/image/2023/12/07/cfa35095c70443d9a997db104e880583.png',
    url: '/pages/userManagement/index',
    badge: null
  },
  {
    name: '结算管理',
    key: 'settlementRecords',
    icon: 'https://res.xiaokunkeji.cn/image/2023/12/07/4faffd44f77849dfb28adf0b376b08d2.png',
    url: '/pages/settlementRecords/index',
    badge: null
  },
  {
    name: '收款账户',
    key: 'accounts',
    icon: 'https://res.xiaokunkeji.cn/image/2026/10/22/26677c2b0a8d455e925f4752f4aabb8b.png',
    url: '/pages/accounts/index',
    badge: null
  },
  {
    name: '发票信息',
    key: 'invoice',
    icon: 'https://res.xiaokunkeji.cn/image/2025/09/12/e9bf6cb7cdae4582bdd4408cf888c26b.png',
    url: '/pages/invoice/index',
    badge: null
  },
  {
    name: '服务协议',
    key: 'assignMent',
    icon: 'https://res.xiaokunkeji.cn/image/2026/10/22/a7a5e4ef7abb4790bac539588a0a3802.png',
    url: '/pages/assignMent/index',
    badge: null
  },
  {
    name: '人脸认证',
    key: 'faceAuthen',
    icon: 'https://res.xiaokunkeji.cn/image/2026/10/22/fa4ba79e0c544ab4b3a756cac8e74e77.png',
    url:
      'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx73576c3cf6b396f8&redirect_uri=https%3A%2F%2Fconfirm.serviceshare.com%2Fpages%2FYoufuSupport.html%23%2Funified-login?appKey=wx73576c3cf6b396f8&response_type=code&scope=snsapi_base&state=1767496543936305#wechat_redirect',
    // 处理滚动事件',
    badge: null
  }
]
export default {
  components: {
    kefu,
    slideTip,
    sildePopup,
    sildePopup2,
    sildePopup3,
    holidayConfirm
  },
  computed: {
    userInfo() {
      return tuhu.store.state.userInfo
    },
    locationInfo() {
      return tuhu.store.state.location
    },
    userAuthList() {
      return this.userInfo.authList || []
    },
    allOrder() {
      const list = this.userAuthList
      return list.findIndex(key => key === 'allOrder') >= 0
    },
    todayOrder() {
      const list = this.userAuthList
      return list.findIndex(key => key === 'todayOrder') >= 0
    },
    marketManage() {
      const list = this.userAuthList
      return list.findIndex(key => key === 'marketingManagement') >= 0
    },
    veryCoupon() {
      const list = this.userAuthList
      return list.findIndex(key => key === 'veryCoupon') >= 0
    },
    tabList() {
      const assignment = this.currentShopData.assignment
      const signFlag = this.currentShopData.signFlag
      const billFlag = this.userInfo.billFlag
      const arr = enterList
        .filter(item => item.key !== 'invoice' || billFlag === 1)
        .filter(item => signFlag !== 0 || (signFlag === 0 && item.key !== 'assignMent'))
        .map(item => {
          return item.key === 'invoice' ? { ...item, hasAuth: billFlag === 1 } : item
        })
      arr.forEach(item => {
        const cItem = this.userAuthList.find(v => v === item.key)
        if (cItem) {
          item['hasAuth'] = true
        } else {
          item['hasAuth'] = false
        }
        if (item.key === 'invoice') item['hasAuth'] = true
        if (!assignment && item.key === 'assignMent') item.badge = '!'
        else item.badge = null
      })
      return arr
    },
    currentShopInfo() {
      return tuhu.store.state.currentShopInfo
    }
  },
  data() {
    window.pagesHomeVUe = this
    return {
      currentIndex: 0,
      noticeDialogs: [
        { id: 4, show: false, containSlideId: true }, //中秋国庆营业确认（最高优先级）
        { id: 1, show: false, containSlideId: true }, //重点税务公告
        { id: 2, show: false, containSlideId: true }, //重要打款公告
        { id: 3, show: false, containSlideId: true } //老板去认证
      ],
      noticeIds: null,
      shopSignUrl: '',
      visibleAssign: false, //是否显示合作协议重新签署弹窗
      pendingAssign: false, //合作协议弹窗延迟标记（等营业确认弹窗关闭后再弹出）
      commonText: '',
      visibleSlidePop: false, //15秒滚动弹窗
      visiblePopup: false,
      tipsVisible: false,
      btn: require('../../imgs/image/t-btn.png'),
      tips: require('../../imgs/images/tips.png'),
      left: require('../../imgs/images/left.png'),
      icon1: require('../../imgs/images/icon1.png'),
      tpVisible: false, // 太平核销券
      CollectionAccount: [],
      userName: '',
      showAllShop: false,
      shopOpen: false,
      shopId: '',
      shopList: [],
      currentShopData: {},
      activeId: 0,
      tabList1: [
        {
          name: '所有订单',
          key: 'allOrder',
          icon: homeCar,
          url: '/pages/orderAll/index'
        }
      ],
      tabList2: [
        {
          name: '今日订单',
          key: 'todayOrder',
          icon: homeCar,
          url: '/pages/orderToday/index'
        }
      ],
      marketManageList: [
        {
          name: '市场经理',
          key: 'marketingManagement',
          icon: homeOrder,
          url: '/pages/marketingManagement/index'
        }
      ],
      shopStatus: '',
      radio: 0,
      vConsolePhone: [
        '15068788141',
        '18379008896',
        '18056928085',
        '16608671350',
        '15257122457',
        '17752526745',
        '19956900629'
      ],
      tiktokVisible: false, //抖音结算说明
      tiktokOrder: {}
    }
  },
  mounted() {
    if (this.vConsolePhone.indexOf(this.userInfo.phone) > -1) {
      let vConsole = new VConsole()
    }
  },
  created() {
    this.init()
    this.processNext()
  },
  methods: {
    // 去签订新的协议
    toAssignMent() {
      tuhu.navigateTo({
        url: '/pages/assignMent/index',
        query: {
          shopId: this.currentShopData.shopId,
          cryptoId: this.currentShopData.cryptoId
        }
      })
    },
    handleClose(id) {
      const index = this.noticeDialogs.findIndex(d => d.id === id)
      this.$set(this.noticeDialogs, index, {
        ...this.noticeDialogs[index],
        containSlideId: true,
        show: false
      })
      // 放假弹窗（id=4）未提交接口，需手动移动 currentIndex 避免重复弹出；其他弹窗走正常 processNext 逻辑
      if (id === 4) {
        this.currentIndex = index + 1
        // 未提交时临时将 4 加入 noticeIds，防止 processNext 再次弹出营业确认
        if (!this.noticeIds.includes(4)) {
          this.noticeIds.push(4)
        }
        // 营业确认关闭后，展示待弹出的合作协议弹窗
        if (this.pendingAssign) {
          this.pendingAssign = false
          this.visibleAssign = true
        }
      }
      setTimeout(() => this.processNext(), 300)
    },
    // 处理下一个弹窗
    processNext() {
      this.noticeIds = this.userInfo.noticeIds || []
      if (this.currentIndex >= this.noticeDialogs.length) return
      const currentDialog = this.noticeDialogs[this.currentIndex]
      const v1 = tuhu.localStorage.getItem('visibleSlidePop') || null
      // 营业确认弹窗（id=4）超过截止时间 2026-09-30 23:59:59 后不再展示，直接跳过
      if (currentDialog.id === 4 && Date.now() > new Date('2026-09-30T23:59:59').getTime()) {
        // 超过截止时间仍需弹出待处理的协议弹窗
        if (this.pendingAssign) {
          this.pendingAssign = false
          this.visibleAssign = true
        }
        this.currentIndex++
        this.processNext()
        return
      }
      // 检查是否存在当前弹窗
      if (!this.noticeIds.includes(currentDialog.id)) {
        console.log('不存在当前弹窗', currentDialog.id)
        this.$set(this.noticeDialogs, this.currentIndex, {
          ...currentDialog,
          containSlideId: false,
          show: true
        })
        return
      } else {
        console.log('存在当前弹窗', currentDialog.id)
        if (currentDialog.id === 1) {
          this.$set(this.noticeDialogs, 0, {
            ...currentDialog,
            containSlideId: true,
            show: v1 == 1 ? true : false
          })
        } else {
          this.$set(this.noticeDialogs, this.currentIndex, {
            ...currentDialog,
            containSlideId: true,
            show: false
          })
        }
        // 营业确认弹窗已提交被跳过时，展示待弹出的合作协议弹窗
        if (currentDialog.id === 4 && this.pendingAssign) {
          this.pendingAssign = false
          this.visibleAssign = true
        }
      }
      this.noticeIds = this.userInfo.noticeIds || []
      // 存在则继续下一个
      this.currentIndex++
      this.processNext()
    },
    // 展示条里点进去
    handleShowSlide(typeIndex) {
      const currentDialog = this.noticeDialogs[typeIndex]
      this.currentIndex = typeIndex
      console.log()
      // 检查是否存在当前弹窗
      this.$set(this.noticeDialogs, typeIndex, {
        ...currentDialog,
        containSlideId: true,
        show: true
      })
    },

    // 抖音核销
    handleDyZone(url) {
      tuhu.navigateTo({
        url: url,
        query: {
          shopId: this.currentShopData.shopId,
          date: moment().format('YYYY-MM-DD')
        }
      })
    },
    // 抖音扫码
    async handleDySRcode() {
      let res = await tuhu.wxsdk.scanDY()

      if (res.resultStr.indexOf('tiktok') > -1) {
        this.getTiktokPreverify(res)
      } else {
        tuhu.navigateTo({
          url: '/pages/tiktok/verify',
          query: {
            path: res.resultStr,
            shopId: this.currentShopData.shopId,

            shopName: this.currentShopData.shopName
          }
        })
      }
    },

    // 抖音保养新核销接口
    async getTiktokPreverify(res) {
      try {
        tuhu.showIndicator()
        const data = await tuhu.fetch(`${config.apis.GET_TIKTOK_MAINTAIM_MERCHANT_PERPARE}`, {
          method: 'post',
          body: JSON.stringify({
            code: res.resultStr,
            shopId: this.currentShopData.shopId
          })
        })
        if (data.code === '200') {
          tuhu.hideIndicator()
          tuhu.toast('核销成功')
        } else {
          tuhu.hideIndicator()
          tuhu.toast(data.message)
        }
      } catch (error) {
        tuhu.hideIndicator()
        console.log('err', error)
        tuhu.toast(error)
      }
    },

    //抖音今天订单数量
    async queryDataList() {
      tuhu.showIndicator()
      const res = await tuhu.fetch(
        `${config.apis.GET_TIKTOK_ORDER_DAY_RECORD}?shopId=${this.currentShopData.shopId}&date=${moment().format(
          'YYYY-MM-DD'
        )}`
      )
      if (res && res.code === '200') {
        this.tiktokOrder = res.data
        tuhu.hideIndicator()
      } else {
        tuhu.hideIndicator()
        tuhu.toast(data.message || '网络错误')
      }
    },

    handleView() {
      if (this.userInfo.billFlag === 0) {
        tuhu.navigateTo({
          url: '/pages/home/text'
        })
      } else if (this.userInfo.billFlag === 1) {
        tuhu.navigateTo({
          url: '/pages/home/textInvoice'
        })
      }
    },
    handleGoToSD() {
      tuhu.navigateTo({
        url: `http://m.hzqmtech.com/distribution/channel/SDSYT_XK/` + this.userInfo.shopId
      })
    },
    handleGoToRX() {
      tuhu.navigateTo({
        url: `http://m.hzqmtech.com/distribution/channel/RXSYT_XK/` + this.userInfo.shopId
      })
    },
    handleGoToTP() {
      tuhu.wxsdk.scanTP()
    },
    async init() {
      await this.getShopList()
      await this.getHomeData()
      // await this.geDataList();
      await this.getTPcode() //暂时用不到
      this.time()
      tuhu.wxsdk.hideBtn() // 禁止分享 复制链接
    },
    time() {
      let nowDate = new Date()
      let startDate = new Date('2025/01/21 00:00:00')
      let endDate = new Date('2025/03/26 23:59:59')
      if (nowDate > startDate && nowDate < endDate) {
        this.commonText = `您好！为了给您提供更加便捷的服务，我们将把小鲲核销的使用平台由原来的“小鲲车服”公众号迁移至“小鲲车服商户端”公众号。请您尽快关注 “小鲲车服商户端” 公众号，并点击左下角的 “商户平台” 进行登录。<br>我们衷心感谢您一直以来对小鲲的支持与信任，若此次迁移给您带来不便，敬请谅解。`
        this.visiblePopup = true
      }
      // tuhu
      //   .fetch(`${config.apis.GET_MERCHANT_VERIFY_FIRST_TIME}`, {
      //     method: "post",
      //     body: JSON.stringify({ shopId: this.userInfo.shopId })
      //   })
      //   .then(data => {
      //     if (data.code === '200') {
      //       let nowDate = new Date();
      //       if (data.data) {
      //         this.commonText = `感谢您对我们的支持！我们更新了系统功能：<br>申请出账时需补充收款人实名认证的手机号码，请如实填写，避免影响出账。如果您在申请出账时遇到无法提交的情况，请尝试刷新页面或清理微信缓存。具体操作为：微信-我-设置-通用-存储空间-缓存-去清理（此操作不会影响历史聊天记录）。如需进一步的帮助，请致电客服热线400-176-8848。对此带来的不便，我们深表歉意，感谢您的理解与支持。 祝好！`;
      //         this.visiblePopup = true;
      //       } else {
      //         let startDate = new Date("2025/01/21 00:00:00");
      //         let endDate = new Date("2025/02/13 23:59:59");
      //         if (nowDate > startDate && nowDate < endDate) {
      //           this.commonText =
      //             "您好！2025年春节将近，我司洗美类线下服务将在2025年1月08日至2025年02月13日(农历正月十六)期间暂停下单或使用，商户端也将在此期间关闭核销功能。 感谢您在过去一年对小鲲科技的支持与信任，小鲲科技全体员工提早祝您春节愉快，万事如意!";
      //           this.visiblePopup = true;
      //         }
      //       }
      //     } else {
      //       tuhu.toast(data.message || "网络错误");
      //     }
      //   });
    },
    closeTipsVisible() {
      localStorage.setItem('isShow', null)
      this.tipsVisible = false
      this.handleView()
    },
    closeTipsVisible2() {
      localStorage.setItem('isShow', null)
      this.tipsVisible = false
    },

    async geDataList() {
      tuhu.fetch(`${config.apis.GET_SHOP_URL_PROVIDE}/${this.userInfo.shopId}/1`).then(data => {
        if (data.code === '200') {
          this.CollectionAccount = data.data
        } else {
          this.CollectionAccount = []
        }
      })
    },
    // 太平核销展示
    async getTPcode() {
      tuhu.fetch(`${config.apis.GET_QUERY_TP}?shopId=${this.userInfo.shopId}`).then(data => {
        if (data.code === '200') {
          if (data.data) this.tpVisible = true
          else this.tpVisible = false
        } else {
          this.tpVisible = false
        }
      })
    },
    async getHomeData() {
      tuhu.showIndicator()
      try {
        const data = await tuhu.fetch(`${config.apis.SWITCH_SHOP}?shopId=${this.userInfo.shopId}`)
        if (data && data.code === '200') {
          this.currentShopData = data.data
          tuhu.sessionStorage.setItem('assignment', !data.data.assignment ? '0' : '1')
          tuhu.sessionStorage.setItem('signFlag', data.data.signFlag)
          this.shopSignUrl = data.data.shopSignUrl
          // 营业确认弹窗优先：noticeIds 含 4 说明已提交不需要弹，直接展示合作协议；否则延迟到营业确认关闭后再弹
          if (!data.data.assignment && data.data.signFlag !== 0) {
            const noticeIds = this.userInfo.noticeIds || []
            if (noticeIds.includes(4)) {
              this.visibleAssign = true
            } else {
              this.pendingAssign = true
            }
          }
          if (data.data.tiktokShop) {
            this.queryDataList()
          }
          const res = await tuhu.fetch(`${config.apis.SHOP_OPEN_INFO}`, {
            method: 'post',
            body: JSON.stringify({
              shopId: data.data.shopId
            })
          })
          if (res && res.code === '200') {
            tuhu.hideIndicator()
            const status = res.data.shopStatus
            this.shopStatus = status
            tuhu.store.commit('setCurrentShopInfo', Object.assign(data.data, { shopStatus: status }))
            // 单选按钮 高亮
            this.shopList.forEach((val, index, arr) => {
              if (val.id === data.data.shopId) {
                this.radio = index
              }
            })
          } else {
            tuhu.hideIndicator()
            tuhu.toast(res.message || '网络错误')
            console.log(`${config.apis.SHOP_OPEN_INFO}`, res)
          }
        } else {
          tuhu.hideIndicator()
          tuhu.toast(data.message || '网络错误')
          console.log(`${config.apis.SWITCH_SHOP}`, data)
        }
      } catch (e) {
        tuhu.hideIndicator()
        console.log(`${config.apis.SWITCH_SHOP}`, e)
      }
    },
    async getShopList() {
      tuhu.showIndicator()
      try {
        const data = await tuhu.fetch(`${config.apis.GET_SHOPLIST_BYID}`, {
          method: 'post',
          body: JSON.stringify({ traderId: this.userInfo.userId })
        })
        if (data && data.code === '200') {
          tuhu.hideIndicator()
          this.shopList = data.data || []
        } else {
          tuhu.hideIndicator()
          tuhu.toast(data.message || '网络错误')
          console.log(`${config.apis.GET_SHOPLIST_BYID}`, data)
        }
      } catch (e) {
        tuhu.hideIndicator()
        console.log(`${config.apis.GET_SHOPLIST_BYID}`, e)
      }
    },
    handleVerify() {
      tuhu.navigateTo({
        url: '/pages/verifyCode/index',
        query: {
          shopId: this.currentShopData.shopId
        }
      })
    },
    handleClick(item) {
      if (!item.hasAuth) return tuhu.toast('您无查看权限')
      if (item.url.indexOf('https://') === 0) {
        location.href = item.url
        return
      }

      if (item.key === 'assignMent' && this.currentShopData.assignment) {
        window.open(this.shopSignUrl)
        //  tuhu.navigateTo({
        //   url: '/pages/common/review',
        //   query: {
        //     url: this.shopSignUrl
        //   }
        //   });
        return
      }
      tuhu.navigateTo({
        url: item.url,
        query: {
          shopId: this.currentShopData.shopId,
          cryptoId: this.currentShopData.cryptoId
        }
      })
    },
    handleClick2(item) {
      if (item.key === 'allOrder') {
        if (this.allOrder) {
          tuhu.navigateTo({
            url: item.url
          })
        } else {
          tuhu.toast('您无查看权限')
        }
      } else if (item.key === 'todayOrder') {
        if (this.todayOrder) {
          tuhu.navigateTo({
            url: item.url
          })
        } else {
          tuhu.toast('您无查看权限')
        }
      } else {
      }
    },
    // 切换门店
    async handleSelect(item) {
      try {
        const data = await tuhu.fetch(`${config.apis.SWITCH_SHOP}?shopId=${item.id}`)
        if (data && data.code === '200') {
          const res = await tuhu.fetch(`${config.apis.SWITCH_USER_COUNT}/${item.id}`)
          if (res && res.code === '200') {
            tuhu.toast('切换成功')
            setTimeout(() => {
              location.reload()
              // this.getShopList();
              // this.getHomeData();
              // this.geDataList();
              this.getTPcode()
            }, 300)
          } else {
            tuhu.toast(res.message || '切换账号出错')
          }
        } else {
          tuhu.toast(data.message || '网络错误')
        }
      } catch (e) {
        console.log(e)
      }
      this.showAllShop = false
    },
    upload(val) {
      if (val && val.code === '200' && val.data) {
        this.shopHeadImg = val.data
        this.changeShopDoorImg(val.data)
      }
    },
    handleOpenTips() {
      tuhu.alert('门店营业状态为已关闭，无法核销，请至【门店信息】开启营业')
    },
    scanQrcode() {
      tuhu.wxsdk.scanQR()
    },
    // 返回到home刷新数据
    onPageBack(to, from) {
      if (to.path.indexOf('/pages/home/index') > -1) {
        this.init()
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import './home.less';

.tips {
  display: flex;
  justify-content: space-between;
  background: rgba(254, 117, 120, 0.1);
  padding: 0 0.5rem;
  border-radius: 0.4rem;
  height: 2rem;
  min-height: 2rem;
  margin-bottom: 0.6rem;

  .left {
    display: flex;
    align-items: center;
    color: #ff1f24;
    font-size: 0.65rem;

    img {
      width: 0.8rem;
      height: 0.8rem;
      margin-right: 0.2rem;
    }
  }

  .right {
    color: #585f6d;
    font-size: 0.65rem;
    display: flex;
    align-items: center;

    img {
      width: 0.7rem;
      height: 0.7rem;
    }
  }
}
</style>

<style lang="less">
.shoplist-popup {
  padding: 0 0.75rem;

  .shop-item {
    padding: 0.5rem 0rem;
    font-size: 16px;
  }

  .selected {
    color: #006eef;
  }
}

.concat {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8ab2fb;
  padding: 1rem 0.5rem;
  border-radius: 5px;
  font-size: 0.7rem;
  font-family: PingFangSC-Semibold, PingFang SC;

  span {
    margin-left: 0.2rem;
  }
}

.total {
  > span {
    color: red;
    font-weight: 400;
    font-size: 1rem;
  }
}

.todayOrder {
  > span {
    color: red;
    font-weight: 400;
    color: rgba(0, 110, 239, 1);
    font-size: 1rem;
  }
}

.custormTips {
  width: 14rem;
  min-height: 19rem;

  // background: url("../../imgs/image/tips.png") no-repeat;
  // background-size: 100% 100%;
  .title {
    font-size: 0.8rem;
    color: #323233;
    font-weight: 600;
    padding: 1.2rem 0.75rem;
    text-align: center;
  }

  .tips {
    height: 2rem;
    // min-height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 1rem;

    img {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 0.3rem;
    }

    color: #ff5000;
    font-size: 0.65rem;
    background: #fef1f1;
    border-radius: 0.2rem;
  }

  .t-content {
    padding: 0 1rem;
    font-size: 0.65rem;
    color: #333333;

    p {
      line-height: 1rem;
    }

    .name {
      padding: 0.75rem 0 0.2rem 0;
    }

    .text {
      span {
        color: #fc1a00;
      }
    }

    .t-btn {
      background: linear-gradient(180deg, #6d8bff 0%, #557afe 100%);
      font-size: 0.7rem;
      color: #fff;
      border-radius: 1rem;
      width: 10rem;
      margin: 0 auto;
      text-align: center;
      height: 2rem;
      line-height: 2rem;
      margin-top: 1rem;
    }

    .close {
      text-decoration: underline #4069ff;
      color: #4069ff;
      line-height: 2.5rem;
      text-align: center;
      font-size: 0.7rem;
    }

    .service-provider {
      text-align: right;
      margin-top: 1rem;
    }
  }
}

.custormTips1 {
  width: 16.75rem;
  border-radius: 0.8rem;
  padding: 1.2rem 1rem;

  .title {
    height: 1.2rem;
    font-size: 0.8rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #09090a;
    line-height: 1.2rem;
    margin-bottom: 0.75rem;
    text-align: center;
  }

  .tips1 {
    width: 14.75rem;
    background: rgba(254, 51, 0, 0.05);
    border-radius: 0.1rem;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.65rem;
    color: #fe0000;
    height: 1.8rem;

    img {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 0.3rem;
    }
  }

  .t-content {
    font-size: 0.65rem;
    color: #333333;

    p {
      line-height: 1.2rem;
    }

    .name {
      padding: 0.75rem 0 0.2rem 0;
    }

    .text {
      margin-bottom: 1.2rem;

      span {
        color: #fc1a00;
      }
    }

    .t-btn {
      font-size: 0.7rem;
      color: #fff;
      border-radius: 1rem;
      margin: 0 auto;
      text-align: center;
      height: 2rem;
      line-height: 2rem;
      width: 11.75rem;
      background: #176df9;
      border-radius: 1rem 1rem 1rem 1rem;
    }
  }
}

.custormTips3 {
  width: 14rem;
  min-height: 19rem;
  background: url('https://res.xiaokunkeji.cn/image/2023/12/12/3be777a1fa0846b68f11c88960bd7433.png') no-repeat;
  background-size: 100% 100%;

  .title {
    font-size: 1.8rem;
    color: #aa6928;
    margin-top: 2.3rem;
    margin-left: 0.8rem;
  }

  .t-content {
    padding: 0 1rem;
    font-size: 0.7rem;
    font-weight: 500;
    color: #333333;

    p {
      line-height: 1rem;
    }

    .name {
      margin: 1.5rem 0 0.4rem 0;
    }

    .service-provider {
      text-align: right;
      margin-top: 1rem;
    }

    .t-btns {
      margin-top: 1.5rem;
    }
  }
}

.custormTips4 {
  width: 14rem;
  min-height: 6rem;

  .t-content4 {
    text-align: center;
    line-height: 3rem;
    height: 3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue